import { useParams, Link } from 'react-router-dom';
import { ArrowLeft, MapPin, Truck } from 'lucide-react';
import { Card } from '@/components/ui/Card';
import { LoadingSpinner } from '@/components/ui/LoadingSpinner';
import { MapPicker } from '@/components/ui/MapPicker';
import { useVehicles } from '@/hooks/useVehicles';
import { vehicleService } from '@/services/vehicleService';
import toast from 'react-hot-toast';

export function VehicleDetailPage() {
  const { id } = useParams<{ id: string }>();
  const { vehicles, loading, refetch } = useVehicles();

  if (loading) return <LoadingSpinner />;

  const vehicle = vehicles.find(v => v.id === id);
  if (!vehicle) {
    return (
      <div className="text-center py-12">
        <p className="text-gray-500">Vehículo no encontrado</p>
        <Link to="/vehicles" className="text-brand-yellow text-sm mt-2 inline-block">Volver a vehículos</Link>
      </div>
    );
  }

  const handleLocationUpdate = async (data: { latitude: number; longitude: number; address: string }) => {
    try {
      await vehicleService.setLocation(vehicle.vehicle_id, {
        ...data,
        label: vehicle.label,
      });
      await refetch();
      toast.success('Ubicación actualizada');
    } catch (err) {
      toast.error(err instanceof Error ? err.message : 'Error al actualizar');
    }
  };

  return (
    <div className="space-y-6 animate-fade-in">
      <div className="flex items-center gap-3">
        <Link to="/vehicles" className="p-2 hover:bg-gray-100 rounded-lg">
          <ArrowLeft size={20} />
        </Link>
        <h1 className="font-heading text-3xl tracking-wider">{(vehicle.label || 'VEHÍCULO').toUpperCase()}</h1>
      </div>

      <Card padding="lg">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-12 h-12 bg-brand-black rounded-xl flex items-center justify-center">
            <Truck size={22} className="text-brand-yellow" />
          </div>
          <div>
            <p className="font-semibold">{vehicle.label}</p>
            {vehicle.city && <p className="text-sm text-gray-500">{vehicle.city}, {vehicle.state}</p>}
          </div>
        </div>

        {vehicle.address && (
          <div className="flex items-start gap-2 mb-4 p-3 bg-gray-50 rounded-xl">
            <MapPin size={16} className="text-brand-yellow mt-0.5 flex-shrink-0" />
            <div>
              <p className="text-sm">{vehicle.address}</p>
              {vehicle.latitude && vehicle.longitude && (
                <p className="text-xs text-gray-400">{vehicle.latitude}, {vehicle.longitude}</p>
              )}
            </div>
          </div>
        )}
      </Card>

      <Card padding="lg">
        <h2 className="font-heading text-xl tracking-wider mb-4">UBICACIÓN BASE</h2>
        <MapPicker
          latitude={vehicle.latitude}
          longitude={vehicle.longitude}
          address={vehicle.address}
          onSelect={handleLocationUpdate}
        />
      </Card>
    </div>
  );
}
